import React from 'react';
import PropTypes from 'prop-types';
import SavingButton from 'library/components/saving-button';

class TargetModalFooter extends React.PureComponent {
  static propTypes = {
    current: PropTypes.number,
    steps: PropTypes.number,
    close: PropTypes.func.isRequired,
    next: PropTypes.func.isRequired,
    prev: PropTypes.func.isRequired,
    nextLabel: PropTypes.string,
    nextSaving: PropTypes.bool
  }

  static defaultProps = {
    current: 1,
    steps: 2,
    close: ()=>{},
    next: ()=>{},
    prev: ()=>{},
    nextLabel: 'Next',
    nextSaving: false,
    disabled: false
  }

  render() {
    const previousDisabled = this.props.current === 1;

    return (
      <div className='personal-target-modal-footer'>
        <button disabled={previousDisabled} className='prev button-tertiary' onClick={this.props.prev}>Prev</button>
        <button className='cancel button-outline-grey-2' onClick={this.props.close}>Cancel</button>
        <SavingButton
          saving={this.props.nextSaving}
          type="submit"
          onClick={this.props.next}
          className='next button-primary'
          disabled={this.props.disabled}
        >
          {this.props.nextLabel}
        </SavingButton>

      </div>
    )
  }
}


export default TargetModalFooter
